import React from 'react';
import './AddButton.scss';

interface AddButtonProps {
  /** Function to handle add action */
  onAdd: () => void;
  /** Custom class name */
  className?: string;
  /** Whether button is disabled */
  disabled?: boolean;
  /** Button label */
  label?: string;
  /** Icon to display */
  icon?: string;
}

/**
 * Generic Add button component
 * Primary action button for adding new items
 */
const AddButton: React.FC<AddButtonProps> = ({
  onAdd,
  className = '',
  disabled = false,
  label = 'Add New',
  icon = '+'
}) => {
  return (
    <button
      className={`add-button ${className}`}
      onClick={onAdd}
      disabled={disabled}
      type="button"
    >
      {icon && <span className="button-icon">{icon}</span>}
      {label}
    </button>
  );
};

export default AddButton;
